import { atomFamily, selectorFamily } from "recoil";

export const hourlyAtom = atomFamily({
  key: "hourlyAtom",
  default: selectorFamily({
    key: "hourlyAtom/Default",
    get:
      (params: any) =>
      // @ts-ignore
      async ({ get }) => {
        const res: any = await hourlyApi.query(params);
        res?.data?.hourList?.length &&
          res?.data.hourList.forEach((item: any) => {
            item.isExpand = false;
          });
        return res ?? {};
      },
  }),
});
/* 
组件中使用：
import { hourlyState } from "@/store/recoil";
const res = useRecoilValue(hourlyState.hourlyAtom({ test: isDevEnv ? 1 : undefined, keyId: isDevEnv ? 2332635 : LocalStorage.getItem("info")?.key || homeState?.info?.key }));
*/
